import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
// Material UI
import {
  Container,
  TextField,
  InputAdornment,
  Button,
  List,
  ListItem,
  Modal,
  Fade,
  Backdrop,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AccountCircleTwoToneIcon from "@material-ui/icons/AccountCircleTwoTone";
import LockTwoToneIcon from "@material-ui/icons/LockTwoTone";

//MessageBox
import LoginMessageBox from "../../components/MessageBox/LoginMessageBox";

//Cookie setter/getter
import { add_cookies } from "../../components/Cookies/Cookies";

import background from "../../assets/img/banner.png";

// Stylesheet
import "./Login.scss";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
    textAlign: "center",
  },
}));

const Login = () => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captchaOn, setCaptchaOn] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [userData, setUserData] = useState(false);

  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("empty");

  const [msgType, setMsgType] = useState("success");
  //Message Box EOF
  const [captchKey, setCaptchaKey] = useState(null);
  let history = useHistory();

      useEffect(() => {
    checkCaptchaOn();
    captcha();
  }, []);

  useEffect(() => {
    //will disable/enable if fields empty/filled
    // if((username !== '') && (password !== '')&& (token !== '')|| (token !== false)){
    if (username !== "" && password !== "" && password !== "") {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [username, password]);

  useEffect(() => {
    if (userData) {
      //if state array not empty
      //1.5 = 1 hour and 30minutes == 90mins cookie lifespan
      add_cookies("user_id", userData.user_id, 24);
      add_cookies("userrole", userData.get_position_access.position, 24);
      add_cookies(
        "fullname",
        userData.firstname +
          " " +
          userData.middlename +
          " " +
          userData.lastname,
        24
      );
      add_cookies("firstname", userData.firstname, 24);
      add_cookies("lastname", userData.lastname, 24);
      add_cookies("branchidno", userData.branchidno, 24);
      add_cookies("is_operational", userData.operational, 24);
      add_cookies("hqlink", JSON.stringify(userData.hqlink), 24);
      add_cookies(
        "main.nav.access",
        JSON.stringify(userData.get_position_access.access_nav),
        24
      );
      add_cookies(
        "content.nav.access",
        JSON.stringify(userData.get_position_access.access_content_nav),
        24
      );
      add_cookies("position_id", JSON.stringify(userData.position_id), 24);
      add_cookies("curcode", userData.curcode, 24);
      add_cookies("can_approve", userData.get_position_access.can_approve, 24);
      add_cookies("can_process", userData.get_position_access.can_process, 24);
      add_cookies("can_delete", userData.get_position_access.can_delete, 24);
      add_cookies("can_edit", userData.get_position_access.can_edit, 24);
      add_cookies("country", userData.country, 24);
      //console.log(JSON.stringify(userData.get_position_access.access_content_nav)));
      //console.log('cookies added');
    }
  }, [userData]);

  const captchaRef = useRef();
  const widgetIdRef = useRef(null);
  const [token, setToken] = useState("");



      const captcha = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "captcha")
      .then(function (res) {
        setCaptchaKey(res.data.success);
      })
      .catch(function (error) {
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  const reloadCaptcha = () => {
  if (window.turnstile && widgetIdRef.current !== null) {
    window.turnstile.reset(widgetIdRef.current);
    setToken(null);
  }
};

  useEffect(() => {
    if (captchKey && window.turnstile) {
      window.turnstile.render(captchaRef.current, { 
        theme: "light",
        sitekey: captchKey,
        callback: (token) => setToken(token),
      });
    }
  }, [captchKey]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      alert("Please complete CAPTCHA.");
      return;
    }

    const res = await fetch("/check_captcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });

    const result = await res.json();

    if (result.success) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false);
      alert("CAPTCHA failed");
    }
  };
  const checkCaptchaOn = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "check_captcha_on")
      .then(function (res) {
        setCaptchaOn(res.data.success);
      })
      .catch(function (error) {
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };


  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      user_login();
    }
  };

  const user_login = async () => {
    console.log("34", captchaOn);
    setBtnDisabled(true); // disable button to avoid multiple saves
    if (captchaOn) {
      if (!token) {
        setShowMsgBox(true);
        setMsg("Please check the CAPTCHA.");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
        return;
      } else {
        const formData = new FormData();
        formData.append("username", username);
        formData.append("password", password);

        const formData2 = new FormData();
        formData2.append("token", token);

        await axios
          .post(process.env.REACT_APP_API_URL + "check_captcha", formData2, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function (res) {
            console.log("erere", res);
            if (res.data.success) {
                axios
                  .post(process.env.REACT_APP_API_URL + "user_login", formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then(function (res) {
                    if (res.data.status !== 1) {
                      let message = res.data.message
                        ? res.data.message
                        : "Invalid username/password"; //fallback value incase message property not found
                      setShowMsgBox(true);
                      setMsg(message);
                      setMsgType("warning");
                           reloadCaptcha();
                      setTimeout(() => {
                        setShowMsgBox(false);
                        setBtnDisabled(false);
                      }, 2000);
                    } else {
                      //success, status == 1
                      localStorage.removeItem("is_logout");
                      add_cookies("username", username, 1.5);
                      setUserData(res.data.data);
                      setShowMsgBox(true);
                      setMsg("Success");
                      setMsgType("success");
                      setTimeout(() => {
                        setShowMsgBox(false);
                        setBtnDisabled(false);
                        history.push("/dashboard");
                      }, 2000);
                    }
                  })
                  .catch(function (error) {
                    setShowMsgBox(true);
                    setMsg("Something went wrong: " + error);
                    setMsgType("warning");
                    setTimeout(() => {
                      setShowMsgBox(false);
                      setBtnDisabled(false); // re-enable
                    }, 2500);
                  });
            } else if (res.status === 400) {
		
		     setShowMsgBox(true);
                      setMsg("CAPTCHA failed");
                      setMsgType("warning");
                      setTimeout(() => {
                        setShowMsgBox(false);
                        setBtnDisabled(false);
                      }, 2000);
            } else {
		     setShowMsgBox(true);
                      setMsg("Something went wrong. Try again later.");
                      setMsgType("warning");
                      setTimeout(() => {
                        setShowMsgBox(false);
                        setBtnDisabled(false);
                      }, 2000);
            }
          })
          .catch(function (error) {
            setShowMsgBox(true);
            setMsg("Something went wrong: " + error);
            setMsgType("warning");
            setTimeout(() => {
              setShowMsgBox(false);
              setBtnDisabled(false); // re-enable
            }, 2500);
          });
      }
    } else {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);

      await axios
        .post(process.env.REACT_APP_API_URL + "user_login", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          if (res.data.status !== 1) {
            let message = res.data.message
              ? res.data.message
              : "Invalid username/password"; //fallback value incase message property not found
            setShowMsgBox(true);
            setMsg(message);
            setMsgType("warning");
                 reloadCaptcha();
            setTimeout(() => {
              setShowMsgBox(false);
              setBtnDisabled(false);
            }, 2000);
          } else {
            //success, status == 1
            localStorage.removeItem("is_logout");
            add_cookies("username", username, 1.5);
            setUserData(res.data.data);
            setShowMsgBox(true);
            setMsg("Success");
            setMsgType("success");
            setTimeout(() => {
              setShowMsgBox(false);
              setBtnDisabled(false);
              history.push("/dashboard");
            }, 2000);
          }
        })
        .catch(function (error) {
          setShowMsgBox(true);
          setMsg("Something went wrong: " + error);
          setMsgType("warning");
          reloadCaptcha();
          setTimeout(() => {
            setShowMsgBox(false);
            setBtnDisabled(false); // re-enable
          }, 2500);
        });
    }
  };

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    localStorage.removeItem("is_logout");
  };

  useEffect(() => {
    if (localStorage.getItem("is_logout")) {
      setShowModal(true);
    }
  }, []);


  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={showModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={showModal}>
          <div className={classes.paper}>
            <h3>Logged Out!</h3>
            <p>You have been idle for too long.</p>

            <Button
              className="login-field-button"
              variant="contained"
              color="primary"
              onClick={handleClose}
            >
              Comfirm
            </Button>
          </div>
        </Fade>
      </Modal>

      <div className="banner">
        <div className="login">
          <LoginMessageBox
            in={showMsgBox}
            content={msgBoxContent}
            type={msgType}
          />
          <div className="login-fields">
            {/* <LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
            <form
              action=""
              autoComplete="off"
              className="login-form"
              onKeyPress={handleKeyPress}
            >
              <div className="login-field-container login-title">
                {/* <LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
                <div className="login-logo-container">
                  <div className="login-logo">
                    <img
                      src={require("../../../src/logo.png")}
                      alt=""
                      style={{ width: "40px" }}
                    />
                  </div>
                  <Typography
                    variant="h6"
                    style={{ color: "#339933!important" }}
                  >
                    JC Headquarters
                  </Typography>
                </div>

                <h2 className="h2" style={{ textAlign: "left" }}>
                  Login
                </h2>
                <Typography className="logo-text">
                  Fill in the fields below to login to your account
                </Typography>
              </div>
              <div className="login-field-container">
                <TextField
                  className="login-field"
                  id="input-with-icon-textfield"
                  variant="outlined"
                  label="Username"
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleTwoToneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="login-field-container">
                <TextField
                  className="login-field"
                  id="input-with-icon-textfield"
                  variant="outlined"
                  label="Password"
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockTwoToneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div
                style={{ display: "flex", justifyContent: "center" }}
                ref={captchaRef}
                className="cf-turnstile"
              />

              <div className="login-field-container login-field-button">
                <Button
                  className="login-field-button"
                  disabled={btnDisabled}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    user_login();
                  }}
                >
                  Login
                </Button>
              </div>
            </form>
          </div>
          {/* <div className="login-graphic">
						<img
							src="/images/login.svg"
							alt=""
							className="login-image"
						/>
					</div> */}
        </div>
      </div>
    </>
  );
};

export default Login;
